module.exports = __webpack_public_path__ + "img/icon_calendar.ca7646b5.svg";